import { CdxLocation } from './../models/cdx-comment';

export class PdfUtils {

  static isScrolledIntoView(el: Element, parent: Element, byHalfContainer: boolean) {
    const containerRect: ClientRect = parent.getBoundingClientRect();
    const elementRect: ClientRect = el.getBoundingClientRect();
    if (byHalfContainer) {
      return !((elementRect.top > containerRect.bottom / 2) || (elementRect.bottom < containerRect.top / 2));
    } else {
      return !(elementRect.top > containerRect.bottom - elementRect.height || elementRect.bottom < containerRect.top + elementRect.height);
    }
  }

  static rotateLocation(_rotation: number, location: CdxLocation, derotate = false) {
    if (_rotation === 0) {
      return location;
    } else if (_rotation === 90) {
      if (derotate) {
        return {
          lon: 100 - location.lat,
          lat: location.lon
        };
      } else {
        return {
          lon: location.lat,
          lat: 100 - location.lon
        };
    }
    } else if (_rotation === 180) {
      return {
        lon: 100 - location.lon,
        lat: 100 - location.lat
      };
    } else if (_rotation === 270) {
      if (derotate) {
        return {
          lon: location.lat,
          lat: 100 - location.lon
        };
      } else {
        return {
          lon: 100 - location.lat,
          lat: location.lon
        };
      }
    }
  }

  public static dataURLToBlob(dataURL): Blob {
    const parts = dataURL.split(';base64,');
    const contentType = parts[0].split(':')[1];
    const raw = atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], { type: contentType });
  }

  public static fileDownload(blob: Blob, filename: string ): void {
    const url = URL.createObjectURL(blob);

    const link: HTMLAnchorElement = document.createElement('a');
    link.classList.add('fileDownload');
    link.href = url;
    link.target = '_blank';
    link.download = filename;

    document.body.appendChild(link);
    link.click();

    URL.revokeObjectURL(url);
  }

  public static filePrint(blob: Blob): void {
    const url = URL.createObjectURL(blob);

    const iframe = document.createElement('iframe');

    document.body.appendChild(iframe);

    iframe.onload = () => {
      try {
        window.addEventListener("focus", () => {
          iframe.remove()
        })

        iframe.contentWindow?.print();
      } catch (error) {
        console.error('Error printing PDF:', error);
        document.body.removeChild(iframe);
        URL.revokeObjectURL(url);
      }
    };

    iframe.onerror = () => {
      console.error('Error loading PDF in iframe');
      document.body.removeChild(iframe);
      URL.revokeObjectURL(url);
    };
    iframe.src = url;
  }

  public static printPdf(src: Uint8Array): void {
    if (!src.length) return;
    const blob = new Blob([src], { type: 'application/pdf' });
    this.filePrint(blob);
  }
}
